import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Aux from "../../../hoc/Auxilliary";
import { makeStyles } from "@material-ui/core/styles";
import { Typography, Grid, Button } from "@material-ui/core/";
import FormStyle from "./prospective.module.css";
import { useSelector } from "react-redux";
import localizedStrings from "../../../utils/localize";

const useStyles = makeStyles((theme) => ({
  TableControl: {
    display: "flex",
    flexDirection: "column",
  },
  formControl: {
    color: "white",
  },
  classConatiner: {
    padding: "1rem 0",
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
  classHeaderFont: {
    fontSize: "1.1rem",
    fontWeight: 800,
    flex: 1,
  },
  classContentFont: {
    fontSize: "1rem",
    flex: 1,
  },
  formDesign: {
    width: "98%",
    margin: "0 auto",
  },
  bottomButton: {
    paddingLeft: "25rem", // Default for larger screens
    [theme.breakpoints.down("lg")]: {
      paddingLeft: "15rem", // For large tablets or smaller desktops
    },
    [theme.breakpoints.down("md")]: {
      paddingLeft: "10rem", // For medium screens
    },
    [theme.breakpoints.down("sm")]: {
      paddingLeft: "5rem", // For small screens (e.g., phones)
    },
    [theme.breakpoints.down("xs")]: {
      paddingLeft: "0.5rem", // For extra-small screens
    },
  },
}));

const Page11 = (props) => {
  const classes = useStyles(props);
  const language = useSelector((state) => state.language.language);
  localizedStrings.setLanguage(language);

  useEffect(() => {
    localizedStrings.setLanguage(language);
  }, [language]);

  return (
    <Aux>
      <Grid xs={12}>
        <Grid style={{ padding: "0 4rem" }}>
          <Typography component="div" className={FormStyle.formContainer}>
            <div className={classes.formDesign}>
              <Typography style={{ paddingTop: "0.5rem", fontWeight: 800 }}>
                Demande d'admission soumise avec succès!
              </Typography>
              <br />
              <Grid>
                <Typography
                  component="div"
                  className={classes.classContentFont}
                >
                  Merci d'avoir déposé une demande d'admission à l'Université de
                  Saint-Boniface.
                </Typography>
                <br />
                <Typography
                  component="div"
                  className={classes.classContentFont}
                >
                  Un courriel de confirmation t’a été envoyé. Si tu ne le reçois
                  pas dans les prochaines minutes, vérifie ta boite de courriels
                  indésirables. Sinon, tu peux nous écrire à l’adresse{" "}
                  <a href="mailto:admissions@ustboniface.ca">
                    admissions@ustboniface.ca
                  </a>{" "}
                  pour faire un suivi.
                  <br /> <br />
                  Un membre de notre équipe traitera ta demande et mettra à jour
                  l’état de la demande dans ton portail au cours des prochains
                  jours. Assure-toi de consulter régulièrement ton portail
                  MonUSB pour suivre la progression de ta demande et savoir
                  quels documents il faudra soumettre.
                  <br /> <br />À bientôt !
                </Typography>
              </Grid>
            </div>
            <br />
            <Grid
              container
              justifyContent="center"
              spacing={2}
              className={classes.bottomButton}
            >
              <Grid item>
                <Link to="/prospective/landingpage">
                  <Button variant="contained" color="primary">
                    RETOUR À LA SECTION DES ADMISSIONS DU PORTAIL
                  </Button>
                </Link>
                <br />
              </Grid>
            </Grid>
          </Typography>
        </Grid>
      </Grid>
    </Aux>
  );
};

export default Page11;
